<template>
  <div>
    <Header />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 mt-10 mb-10">
        <div class="flex flex-col gap-5" v-if="currentBatchData == null">
          <h1 class="text-primary text-3xl font-bold">Batches</h1>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
            <div
              v-for="batch in batchList"
              :key="batch"
              @click="getInstructor"
              class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
            >
              <div
                class="lg:px-8 h-full px-6 flex flex-col items-center justify-center gap-4"
              >
                <!-- {{ batch }} -->

                <h1 class="font-bold text-xl lg:text-xl prime text-center">
                  {{ batch.year }} 
                </h1>

                <p
                  @click="getSemesterList(batch.id, batch)"
                  class="bg-primary text-white px-6 py-1.5 rounded-full text-center cursor-pointer"
                >
                  Batch Details
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="this.currentSemesterData == null"> 
            <div class="flex flex-col gap-5" v-if="currentBatchData != null">

                <div class="flex cursor-pointer" @click="this.currentBatchData = null"> 
                    <p
                    class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                    >
                    Back
                    </p> 
                </div>

                <h1 class="text-primary text-3xl font-bold">Semesters of ( {{ currentBatchData.year }} )</h1>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                    <div
                    v-for="semester in semeterList"
                    :key="semester"
                    @click="getInstructor"
                    class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
                    >
                    <div
                        class="lg:px-8 h-full px-6 flex flex-col gap-4"
                    >
                    
                        <h1 class="font-bold text-xl lg:text-xl prime text-left">
                            Semester {{ semester.semester }}
                        </h1>

                        <p>Batch: {{ currentBatchData.year }} </p>

                        <p>Courses: {{ semester.course.length }}</p>
                        
                        <p
                        @click="getSemesterCourses(semester.id, semester)"
                        class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                        >
                        Semester Courses
                        </p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="flex flex-col gap-5" v-if="currentSemesterData != null">

            <div class="flex cursor-pointer" @click="this.currentSemesterData = null"> 
                <p
                  class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                >
                  Back
                </p> 
            </div>
           
          <h1 class="text-primary text-3xl font-bold">Courses (Sem {{ currentSemesterData.semester }})</h1>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
            <div
              v-for="course in courseList"
              :key="course"
              class="flex flex-col py-6 rounded-3xl shadow-xl h-[500px] cursor-pointer"
            >
              <div
                class="lg:px-8 h-full px-6 flex flex-col gap-4"
              >
                <!-- {{ course }} -->
                <div class="h-[55%]"> 
                  <img :src="course.thumbnail" class="h-[250px] rounded-xl w-full object-cover" alt="">
                  </div>
                
                

                <div class="h-[35%] flex flex-col justify-between"> 
                  <h1 class="font-bold text-xl lg:text-xl prime text-left">
                    {{ course.title.slice(0, 70) }}
                    <span v-if="course.title.length > 70">...</span>
                </h1> 

                  <p>Sections: {{ course.sections.length }}</p> 

                  <div class="flex items-center justify-between gap-4 mt-2">
                  
                  <router-link
                    :to="{
                      name: 'InstructorCourseAdd',
                      params: { course_id: course.id },
                    }"
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" />
                  </router-link>

                  <!-- <router-link
                    :to="{
                      name: 'InstructorCourseEdit',
                      params: { course_id: course.id },
                    }"
                  >
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </router-link>
                  <div
                    @click="
                      titlepass = course.title;
                      popupwindow = true;
                      idpass = course.id;
                    "
                    class="cursor-pointer"
                  >
                    <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                  </div> -->
                </div>
                
                <router-link
                  :to="{
                    name: 'InstructorStudents',
                    params: { course_id: course.id, department_id: course.department.id  },
                  }"
                  class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                >
                  Courses Dashboard
                </router-link> 
                </div>
                
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

   
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

import axios from "axios";

export default {
  components: {
    Header,
    Footer,
  },
  computed: mapGetters(["userInfo"]),

  data() {
    return {
      batchList: [],
      currentBatchData: null,
      semeterList: [],
      currentSemesterData: null,
      courseList: [],
      currentTab: "",
    };
  },

  created() {
    this.getBatchList();
  },

  methods: {
    getBatchList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.batchList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getSemesterList(id, data) {
        this.semeterList =[];
      this.currentBatchData = data;

      axios
        .get(
          `${process.env.VUE_APP_API}/hod/semesters-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.semeterList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },


    getSemesterCourses(id, data) {
        this.courseList =[];
      this.currentSemesterData = data;
      axios
        .get(
          `${process.env.VUE_APP_API}/hod/course-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.courseList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
};
</script>

<style></style>
